import { useMutation } from '@tanstack/react-query';
import { deleteRevision } from '../queries/post';

export function useDeletePracticeRevision() {
  const { mutate, data, isPending, isSuccess } = useMutation({
    mutationKey: ['deletePracticeRevision'], 
    mutationFn: (id: string) => deleteRevision(id),
    retry: false
  });

  return { mutate, data, isPending, isSuccess };
}
